<script setup lang="ts">
import { useRoute } from 'vue-router';
import { i18n } from '@/i18n';
import { ITabRoute } from '@/coreDomainsModule/tabRoutes';
import { computed } from 'vue';

const t = i18n.t;
const route = useRoute();

const tabRoutes: Array<ITabRoute> = [
  {
    name: 'データ入力',
    path: '/input-data',
  },
  {
    name: '取引削除',
    path: '/business-removal',
  },
  {
    name: '取引一括編集',
    path: '/business-edit/bulk',
  },
  {
    name: '選択肢編集',
    path: '/business-edit/master',
  },
];

const baseRoute = computed(() => `/${route.path.split('/').filter(Boolean)[0]}`);
</script>
<template>
  <div class="tab__container">
    <div v-for="tab in tabRoutes" :key="tab.path">
      <router-link :to="tab.path">
        <div :class="baseRoute === tab.path || route.path === tab.path ? 'tab__active' : 'tab__inactive'">{{ t(tab.name) }}</div>
      </router-link>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.tab {
  &__container {
    max-height: 40px;
    display: grid;
    grid-template-columns: repeat(5, auto);
    grid-gap: 16px;
    justify-content: start;
  }

  &__active {
    font-family: Noto Sans JP;
    font-size: 14px;
    font-weight: 700;
    line-height: 14px;
    letter-spacing: 0em;
    text-align: center;
    border-bottom: 2px solid #1e92ef;
    color: #212121;
    padding: 8px 0;
    height: 100%;
    align-content: center;
  }

  &__inactive {
    font-family: Noto Sans JP;
    font-size: 14px;
    font-weight: 400;
    line-height: 14px;
    letter-spacing: 0em;
    text-align: center;
    color: $textSecondary;
    padding: 8px 0;
    height: 100%;
    align-content: center;
  }
}
</style>
